import FieldSet from '../../FieldSet';

import { ProgressBar } from './ProgressBar';

export class ProgressFieldSet extends FieldSet {
  get fieldDefinitions() {
    return [ProgressBar];
  }

  get title() {
    return 'Progress';
  }
}
